/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const StatusCountDTOStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Suspended: 'SUSPENDED',
    Exported: 'EXPORTED',
    Unavaliable: 'UNAVALIABLE',
    WaitingResults: 'WAITING_RESULTS'
};
/**
 * Check if a given object implements the StatusCountDTO interface.
 */
export function instanceOfStatusCountDTO(value) {
    return true;
}
export function StatusCountDTOFromJSON(json) {
    return StatusCountDTOFromJSONTyped(json, false);
}
export function StatusCountDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'] == null ? undefined : json['status'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}
export function StatusCountDTOToJSON(json) {
    return StatusCountDTOToJSONTyped(json, false);
}
export function StatusCountDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'count': value['count'],
    };
}
